import { render } from "./CategoryFormModal.vue?vue&type=template&id=bc81a59c"
import script from "./CategoryFormModal.vue?vue&type=script&lang=js"
export * from "./CategoryFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__